import {ColumnsType} from "antd/lib/table";
import {PriceDto, PriceUpdateDto} from "../../api";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {AsyncButtonPopconfirm, CrudTable, nameof} from "digimuth-components/dist";
import {Button, Typography} from "antd";
import styles from "./priceListContainer.module.scss";
import {Dispatch, SetStateAction} from "react";
import InlineEditableNumber from "../../components/inlineEditableNumber/inlineEditableNumber";

const {Text} = Typography;

export default function PricesList(props: PricesListProps) {

    const onPriceChange = (e: string, record: PriceDto) => {
        record.value = Number(e);
        props.newValues.push(record);
        props.setNewValues([...props.newValues]);
        props.onEdit(props.newValues);
    }

    const onDescriptionChange = (e: string, record: PriceDto) => {
        record.description = e;
        props.newValues.push(record);
        props.setNewValues([...props.newValues]);
        props.onEdit(props.newValues);
    }

    const columns: ColumnsType<PriceDto> = [
        {
            key: nameof<PriceDto>("value"),
            dataIndex: nameof<PriceDto>("value"),
            title: "Wartość (zł)",
            render: (value, record, idx) => {
                const newPrice = props.newValues.find(v => v.id === idx);
                return <InlineEditableNumber
                    key={idx * 2}
                    editable={true}
                    value={newPrice ? newPrice.value : value.toString()}
                    onSave={e => onPriceChange(e, record)} />
            }
        },
        {
            key: nameof<PriceDto>("description"),
            dataIndex: nameof<PriceDto>("description"),
            title: "Opis",
            render: (value, record, idx) => {
                const newDescription = props.newValues.find(v => v.id === idx);
                return <Text
                    key={idx * 2 + 1}
                    editable={{onChange: (e) => onDescriptionChange(e, record)}}>
                    {newDescription ? newDescription.description : value}
                </Text>
            }

        }
    ];

    return <>
        <Button type="primary" onClick={props.onAddClicked} className={styles.newPriceButton}>
            + Dodaj nową cenę
        </Button>
        <CrudTable
            data={props.data}
            columns={columns}
            actionsFixed={false}
            cancelButtonTitle="Anuluj"
            isLoading={props.isLoading}
            customRowActions={record =>
                <AsyncButtonPopconfirm
                    title={"Czy na pewno chcesz usunąć tę cenę?"}
                    danger
                    onConfirm={() => props.onPriceDelete(record)}
                    okText={"Ok"}
                    cancelText={"Anuluj"}
                >
                    Usuń
                </AsyncButtonPopconfirm>}
        />
    </>
}

interface PricesListProps extends CrudTableWrapperProps<PriceDto> {
    newValues: PriceUpdateDto[];
    setNewValues: Dispatch<SetStateAction<PriceUpdateDto[]>>;
    onEdit: (values: PriceUpdateDto[]) => void
    onPriceDelete: (record:PriceDto) => void;
}
